import * as types from '@/store/types'
export default {
    getLoadedStatus: state => {
        return state.loaded
    },
    getMessagesDialog: state => {
        return state.messagesDialog
    },
    getMessagesDialogChat: state => {
        return state.messagesDialogChat
    }
}
